import { PRICING } from '@/constants/pulse/deltaPricing';
import { ResponseData, outputMap } from './DeltaOffers';

interface Payload {
    priorRelationship: string; // FST_TRIAL, PRIOR_SFLPY, PRIOR_NON_CONV, UNK (paid media)
    journeyStage: string; // Onboarding, InTrial, Winback
    cohort: string; // sports, country, pop, news, general
}

export const generateDeltaOffer = (payload: Payload): ResponseData => {
    const { priorRelationship, journeyStage, cohort } = payload;
    const key = `${priorRelationship}_${journeyStage}_${cohort}`;

    const responseData = outputMap[key];
    if (responseData) {
        return responseData;
    }

    // Default offer if responseData not found - matches paid media
    const url = cohort === 'sports'? `${PRICING.url2for3UnknownSport}` : `${PRICING.url2for3Unknown}`;
    return {
        offer: `${PRICING.offer2for3}`,
        terms: `${PRICING.terms2for3AllAccess}`,
        tagline: `${PRICING.taglineAllAccess}`,
        tier: `${PRICING.tierAllAccess}`,
        url: url,
        offerName: `${PRICING.offerKey2for3AllAccess}`,
    };
};

export const createDeltaOfferPayload = (
    priorRelationship: string,
    journeyDaysParam: string,
    pageSlug: string,
): ResponseData => {
    const cohort = getCohortFromSlug(pageSlug);
    let journeyStage = "";
    if (journeyDaysParam && Number(journeyDaysParam)) {
        const journeyDays =  Number(journeyDaysParam);
        journeyStage =
            journeyDays !== undefined
                ? journeyDays <= 30
                    ? PRICING.onboarding
                    : journeyDays <= 90
                        ? PRICING.inTrial
                        : PRICING.winback
                : PRICING.onboarding;
    } else {
        journeyStage = journeyDaysParam ? journeyDaysParam : PRICING.onboarding;
    }

    return generateDeltaOffer({
        priorRelationship: priorRelationship ?? '',
        journeyStage: journeyStage ?? '',
        cohort: cohort,
    });
};

export const getCohortFromSlug = (slug: string): string => {
    const lastDashIndex = slug.lastIndexOf('-');
    return slug.substring(lastDashIndex + 1);
};

